module.exports = __webpack_public_path__ + "img/whole_creation.0d06eaf9.png";